<div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
  <div class="text-bold">
    {{ monthLabel }}
  </div>

  <div class="text-sm">
    <div>
      <span class="text-xs" [ngClass]="isRatingDown() ? 'text-danger' : 'text-success'">
        {{ isRatingDown() ? '⬇' : '⬆' }} </span
      ><span class="text-bold">{{ item?.averageOverallRating | number : '0.0-2' }}</span>
    </div>
    <div class="text-muted">{{ getTotalCount(item) }} <ng-container i18n>reviews</ng-container></div>
  </div>
</div>
<div class="p-3">
  <div *ngFor="let t of ratingCategories" class="d-flex align-items-center justify-content-between">
    <app-rating [rating]="t.value" [showLevelColor]="true" class="text-xxl" style="letter-spacing: 5px"></app-rating>
    <div class="text-sm">
      <div class="text-bold">{{ t.label }}</div>
      <div class="text-muted">{{ getLevelCount(item, t.range) }} <ng-container i18n>reviews</ng-container></div>
    </div>
  </div>
</div>
